// extracted by mini-css-extract-plugin
export default {"list":"GroupList_list__FGpZh","littleList":"GroupList_littleList__1dAab"};